import { render, staticRenderFns } from "./MessageRow.vue?vue&type=template&id=43932560"
import script from "./MessageRow.vue?vue&type=script&lang=js"
export * from "./MessageRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports